import { render, staticRenderFns } from "./employeeDtl.vue?vue&type=template&id=57b98a53&scoped=true&"
import script from "./employeeDtl.vue?vue&type=script&lang=js&"
export * from "./employeeDtl.vue?vue&type=script&lang=js&"
import style0 from "./employeeDtl.vue?vue&type=style&index=0&id=57b98a53&prod&scoped=true&lang=css&"
import style1 from "./employeeDtl.vue?vue&type=style&index=1&id=57b98a53&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b98a53",
  null
  
)

export default component.exports